import { useField, Field } from "./useField.js";
import { useForm } from "./useForm.js";
import { getValidateFormData } from "./validateFormData.js";
function createFormFactory(defaultOpts) {
  return {
    useForm: (opts) => {
      const formOptions = Object.assign({}, defaultOpts, opts);
      return useForm(formOptions);
    },
    useField,
    Field,
    validateFormData: getValidateFormData(defaultOpts),
    initialFormState: {
      errorMap: {
        onServer: void 0
      },
      errors: []
    }
  };
}
export {
  createFormFactory
};
//# sourceMappingURL=createFormFactory.js.map
